import { ControlItem } from './control-item';

export interface BoardUsersInfo {
    Language: string;
    Name: string;
    MinFwVer: string;
    AccessRights: string;
    ControlItem: ControlItem;
    Max: number;
    Used: number;
    UsedDb: number;
    Types: any[];
}

export const needBUResync = (bui: BoardUsersInfo): boolean => bui.Used !== bui.UsedDb;
